import { services } from '@ambita/ambita-components-core';
import { TagInterface } from 'riot';

export interface CurrencyTag extends TagInterface {
  opts: {
    infolandCurrencyAmount: number;
    infolandCurrencySymbol?: string;
    infolandCurrencyPosition?: string;
    infolandCurrencyFraction?: number;
  };
  content?: string;
}

const formatValue = function (this: CurrencyTag): void {
  this.content = services.filters.currency(
    this.opts.infolandCurrencyAmount,
    this.opts.infolandCurrencySymbol,
    this.opts.infolandCurrencyPosition,
    this.opts.infolandCurrencyFraction
  );
};

export const init = function (tag: CurrencyTag): void {
  tag.on('update', formatValue);
  tag.on('before-mount', formatValue);
};
